export default function AnnouncementsTrigger({announcements}) {
    if(announcements.length === 0) return null;

    return <a className="btn btn-sm" data-bs-toggle="collapse" href="#announcementCollapse" role="button" aria-expanded="false" aria-controls="announcementCollapse">
        <i className="fa fa-bullhorn" style={{marginRight: '0.5rem'}}></i>
        <span className="badge bg-dark rounded-pill text-light">{announcements.length}</span>
        <span className="visually-hidden">dismissed {announcements.length === 1 ? 'announcement' : 'announcements' }</span>
    </a>
}